import React, { useState, useEffect } from "react";
import { FiCopy, FiCheck } from "react-icons/fi";

const TemporaryLinkModal = ({ isOpen, onClose, fileId, fileName, module }) => {
  const [loading, setLoading] = useState(false);
  const [link, setLink] = useState("");
  const [error, setError] = useState("");
  const [copied, setCopied] = useState(false);
  const [validHours, setValidHours] = useState(24); // 默认24小时有效期

  useEffect(() => {
    if (isOpen && fileId) {
      generateTemporaryLink();
    }
  }, [isOpen, fileId]);

  const generateTemporaryLink = async () => {
    if (!fileId) return;

    setLoading(true);
    setError("");

    try {
      const token = localStorage.getItem('token');
      if (!token) {
        throw new Error('No authentication token found');
      }

      const userId = localStorage.getItem('userId');

      const response = await fetch('/api/share-file', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          fileId,
          module,
          userId,
          hoursValid: validHours
        }),
      });

      if (!response.ok) {
        const data = await response.json();
        throw new Error(data.error || 'Failed to generate temporary link');
      }

      const data = await response.json();
      setLink(data.link);
    } catch (err) {
      console.error('Error generating temporary link:', err);
      setError('Failed to generate temporary link: ' + err.message);
    } finally {
      setLoading(false);
    }
  };

  const copyToClipboard = () => {
    navigator.clipboard.writeText(link).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  const handleHoursChange = (e) => {
    const hours = parseInt(e.target.value, 10);
    if (!isNaN(hours) && hours > 0) {
      setValidHours(hours);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-lg">
        <h2 className="text-xl font-semibold mb-4">Temporary Download Link</h2>
        <p className="mb-4">File: {fileName}</p>

        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Valid for (hours):
          </label>
          <div className="flex items-center">
            <input
              type="number"
              value={validHours}
              onChange={handleHoursChange}
              min="1"
              max="168"
              className="w-20 mr-2 p-2 border rounded"
            />
            <button
              onClick={generateTemporaryLink}
              disabled={loading}
              className="bg-blue-500 text-white px-3 py-1 rounded hover:bg-blue-600 text-sm"
            >
              {loading ? "Generating..." : "Regenerate"}
            </button>
          </div>
          <p className="text-xs text-gray-500 mt-1">
            Link will expire after the specified number of hours
          </p>
        </div>

        {error && (
          <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4">
            {error}
          </div>
        )}

        {link && (
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Temporary Link:
            </label>
            <div className="flex">
              <input
                type="text"
                value={link}
                readOnly
                className="flex-grow p-2 border rounded-l"
              />
              <button
                onClick={copyToClipboard}
                className="bg-gray-200 px-3 py-2 rounded-r border-t border-r border-b flex items-center"
              >
                {copied ? <FiCheck className="text-green-600" /> : <FiCopy />}
              </button>
            </div>
            <p className="text-xs text-gray-500 mt-1">
              Anyone with this link can download the file until it expires
            </p>
          </div>
        )}

        <div className="flex justify-end">
          <button
            onClick={onClose}
            className="bg-gray-300 text-black px-4 py-2 rounded hover:bg-gray-400"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default TemporaryLinkModal;